module.exports = __webpack_public_path__ + "static/media/reny-2.aa3281a5.jpg";